
export default {
    props: {
        /**
         * Should we use a compact inline button?
         */
        compact: {
            type: Boolean,
            default: false,
        },
        /**
         * A form object
         */
        form: {
            type: Object,
            default() {
                return {};
            },
        },
        /**
         * Button type
         * primary, link, error, success
         */
        type: {
            type: String,
            default: 'primary',
        },
    },
    computed: {
        button() {
            if (this.compact) {
                return `btn-${this.type}`;
            }
            return `btn-${this.type} btn-block`;
        },
    },
};
